import { render } from "./match-details-modal.vue?vue&type=template&id=33ce6a1e&ts=true"
import script from "./match-details-modal.vue?vue&type=script&lang=ts"
export * from "./match-details-modal.vue?vue&type=script&lang=ts"

import "./match-details-modal.vue?vue&type=style&index=0&id=33ce6a1e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__